import React, { useEffect, useState } from "react";

export default function InfoLine() {
  const [country, setCountry] = useState("...");
  const [timeZone, setTimeZone] = useState(Intl.DateTimeFormat().resolvedOptions().timeZone);
  const [time, setTime] = useState("");
  const [ampm, setAmPm] = useState("");
  const [offset, setOffset] = useState("");

  useEffect(() => {
    let active = true;

    // fetch country using IP, but keep the UI stable if the request is blocked
    fetch("https://ipapi.co/json/")
      .then((res) => res.json())
      .then((data) => {
        if (!active) return;
        setCountry(data.country_name || "Unknown");
        setTimeZone(data.timezone || Intl.DateTimeFormat().resolvedOptions().timeZone);
      })
      .catch(() => {
        if (!active) return;
        setCountry("Unknown");
      });

    // keep updating time + offset
    const timer = setInterval(() => {
      const now = new Date();

      setTime(
        now
          .toLocaleTimeString([], { hour: "2-digit", minute: "2-digit", hour12: true })
          .replace(/AM|PM/, "")
          .trim()
      );

      setAmPm(now.getHours() >= 12 ? "PM" : "AM");

      const offsetMinutes = now.getTimezoneOffset();
      const sign = offsetMinutes <= 0 ? "+" : "-";
      const hours = String(Math.floor(Math.abs(offsetMinutes) / 60)).padStart(2, "0");
      const minutes = String(Math.abs(offsetMinutes) % 60).padStart(2, "0");
      setOffset(`${sign}${hours}:${minutes}`);
    }, 1000);

    return () => {
      active = false;
      clearInterval(timer);
    };
  }, []);

  return (
    <div
      id="info-line"
      style={{
        position: "fixed",
        bottom: 70,
        left: 35,
        transform: "rotate(-90deg) translateY(-100%)",
        transformOrigin: "left bottom",
        whiteSpace: "pre",
        fontSize: "12px",
        color: "white",
        fontFamily: "monospace",
        zIndex: 100,
      }}
    >
      {`${country}                ${offset}                ${timeZone}                ${time}                ${ampm}`}
    </div>
  );
}
